module.exports = __webpack_public_path__ + "img/43-574b8e.png";